module.exports = __webpack_public_path__ + "img/ct_armcl.21dbcb48.png";